import { useCurrentUserCompanyId } from 'hooks/company';
import { useEffect } from 'react';

import { useSearchTalentsToSendMessageLazyQuery } from '@libs/graphql-types';

import { getStatusFilters } from '../../../utils';
import { FormModel } from '../types';

export const useTalentCount = (
  values: FormModel,
  scopedCompanyId: string | undefined,
) => {
  const [getTalents, { loading, data }] =
    useSearchTalentsToSendMessageLazyQuery();
  const companyId = useCurrentUserCompanyId();

  useEffect(() => {
    const tags = values.tags.map((i) => i.value) as string[];
    const { includeActive, includeStatic } = values;

    getTalents({
      variables: {
        source_type: 'OWN',
        connection_with_company_id: scopedCompanyId,

        category_ids: values.category ? [values.category] : undefined,
        tags_ids: tags,
        first: 100000,
        zip_codes: values.zipCode as unknown as string[],

        ...(values.country && { country: values.country }),
        ...getStatusFilters({
          isActive: includeActive,
          isStatic: includeStatic,
        }),
      },
    });
  }, [getTalents, values, scopedCompanyId, companyId]);

  return { count: data?.talentsSearch?.data.length || 0, loading };
};
